/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetTournamentsPagedQueryResponse,
  GetTournamentsPagedQueryParams,
  GetTournamentsPaged500,
} from "../types/GetTournamentsPaged.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getTournamentsPagedQueryKey = (
  params?: GetTournamentsPagedQueryParams,
) => [{ url: "/tournaments/paged" }, ...(params ? [params] : [])] as const;

export type GetTournamentsPagedQueryKey = ReturnType<
  typeof getTournamentsPagedQueryKey
>;

/**
 * {@link /tournaments/paged}
 */
export async function getTournamentsPaged(
  params?: GetTournamentsPagedQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetTournamentsPagedQueryResponse,
    ResponseErrorConfig<GetTournamentsPaged500>,
    unknown
  >({ method: "GET", url: `/tournaments/paged`, params, ...requestConfig });
  return res;
}

export function getTournamentsPagedQueryOptions(
  params?: GetTournamentsPagedQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getTournamentsPagedQueryKey(params);
  return queryOptions<
    ResponseConfig<GetTournamentsPagedQueryResponse>,
    ResponseErrorConfig<GetTournamentsPaged500>,
    ResponseConfig<GetTournamentsPagedQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getTournamentsPaged(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * {@link /tournaments/paged}
 */
export function useGetTournamentsPaged<
  TData = ResponseConfig<GetTournamentsPagedQueryResponse>,
  TQueryData = ResponseConfig<GetTournamentsPagedQueryResponse>,
  TQueryKey extends QueryKey = GetTournamentsPagedQueryKey,
>(
  params?: GetTournamentsPagedQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetTournamentsPagedQueryResponse>,
        ResponseErrorConfig<GetTournamentsPaged500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getTournamentsPagedQueryKey(params);

  const query = useQuery(
    {
      ...getTournamentsPagedQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetTournamentsPaged500>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
